import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SupportLink } from './SupportLink';

interface WalletErrorNoticeProps {
  message: string;
  compact?: boolean;
}

export function WalletErrorNotice({ message, compact = false }: WalletErrorNoticeProps) {
  const { t } = useTranslation();

  return (
    <div className={`wallet-error${compact ? ' wallet-error--compact' : ''}`} role="alert">
      <CircleAlert size={compact ? 17 : 20} aria-hidden="true" />
      <div>
        <strong>{t('walletErrors.title')}</strong>
        <p>{message}</p>
        <SupportLink variant="hint" />
      </div>
    </div>
  );
}
